export default {
  dataIterator: {
    rowsPerPageText: "Rader per side:",
    rowsPerPageAll: "Alle",
    pageText: "{0}-{1} av {2}",
    noResultsText: "Ingen resultat",
    nextPage: "Neste side",
    prevPage: "Forrige side"
  },
  dataTable: {
    rowsPerPageText: "Rader per side:"
  },
  noDataText: "Ingen data tilgjengelig",
  carousel: {
    prev: "Forrige",
    next: "Neste"
  }
};
